module.exports = __webpack_public_path__ + "assets/img/logo2.46cab622.png";